import type { AiBusinessCenterModule } from '../types'

export const iotModule: AiBusinessCenterModule = {
  key: 'iot',
  label: 'IoT 物联网',
  desc: '设备接入 / 产品管理 / 规则引擎 / 告警中心',
  path: '/iot',
  homePath: '/iot/home',
  icon: 'fa-solid:hdd',
  color: '#8b5cf6',
  aliases: ['IoT', '物联网']
}
